// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:44.227Z
// Property: Country Hollow Apartments (ID: 6767906449165598)
// Collections: 16 amenities, 3 floorplans (live), 24 photos, 61 POIs, 5 reviews, 1 virtual tours, 7 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165598",
  "property_external_id": "hvrpp32",
  "property_zillow_url": "https://www.zillow.com/b/country-hollow-tulsa-ok-5XhzPY/",
  "property_apartments_url": "https://www.apartments.com/country-hollow-apartments-tulsa-ok/hvrpp32/",
  "property_google_business_url": "https://www.google.com/maps/place/Country+Hollow+Apartments/data=!4m2!3m1!1s0x0:0x945f3018600fd90?sa=X&ved=2ahUKEwiZu-LQ9rySAxWIkmoFHaTOPMQQ_BJ6BAgUEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "country-hollow-apartments",
  "property_name": "Country Hollow Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/country-hollow/",
  "property_domain": null,
  "property_address": "4605 East 80th Street",
  "property_full_address": "4605 East 80th Street, Tulsa, OK, 74136",
  "property_address_1": "4605 East 80th Street",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74136",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0494",
  "property_address_longitude": "-95.9241",
  "property_email": "countryhollow@caseusa.com",
  "property_phone": "(539) 328-7085",
  "property_call_tracking_phone": "855-738-0148",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Country Hollow Apartments in Tulsa, Oklahoma, invites you to experience stylish living with one- and two-bedroom floor plans. Enjoy amenities like a sparkling pool, fitness center, and tennis court, all nestled near scenic walking trails. Embrace comfort and convenience—your perfect home awaits. Browse our availability or schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Welcome to Country Hollow Apartments in Tulsa, Oklahoma!** \n\nDiscover your ideal living space with our thoughtfully designed floor plans, featuring both one-bedroom and two-bedroom options to suit your lifestyle. At Country Hollow Apartments, we prioritize comfort and convenience, ensuring a seamless living experience with a variety of modern amenities. \n\nDive into relaxation at our shimmering swimming pool, or get your sweat on at our fully-equipped fitness center. Enjoy the ease of on-site laundry facilities and maintenance, with a dedicated property manager always available to assist you. Our vibrant clubhouse and business center provide the perfect spaces for both work and play, while our walking and biking trails invite you to explore the beautiful surroundings.\n\nMake the most out of sunny days with our tennis court, picnic area, and grill for delightful outdoor gatherings. Each apartment is equipped with essential amenities such as air conditioning, high-speed internet access, and spacious walk-in closets. Enjoy cooking in your kitchen featuring a refrigerator, dishwasher, oven, and ample pantry space.\n\nWith air conditioning, ceiling fans, and various flooring options including carpet and vinyl, every unit is designed with your comfort in mind. Bask in the tranquility of your own balcony or patio, perfect for unwinding after a busy day.\n\nAt Country Hollow Apartments, we believe that a sense of community is essential. Join us today and discover a lifestyle that blends leisure and convenience right in the heart of Tulsa. \n\n**Find your new home today – browse our availability or schedule a tour to visit our community!**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
    "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
    "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "280",
  "property_year_built": "1976",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.42857142857143",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": null,
  "property_pet_policy_description": "Pet Information",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://countryhollowapartmentstulsa.securecafe.com/onlineleasing/country-hollow-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://countryhollowapartmentstulsa.securecafe.com/residentservices/country-hollow-apartments/userlogin.aspx",
  "property_apply_now_url": "https://countryhollowapartmentstulsa.securecafe.com/onlineleasing/country-hollow-apartments/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-6d72-70d6-bd2f-edb6b97bac8a.webp",
  "property_primary_logo_media": {
    "alt_text": "Country Hollow Apartments logo",
    "public_id": "019cfb3d-6d72-70d6-bd2f-edb6b97bac8a",
    "storage_key": "property/6767906449165598/019cfb3d-6d72-70d6-bd2f-edb6b97bac8a.webp",
    "width": 210,
    "height": 122
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3e-8848-71d1-a512-244922b21fa3.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3e-8848-71d1-a512-244922b21fa3",
    "storage_key": "property/6767906449165598/019cfb3e-8848-71d1-a512-244922b21fa3.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3e-a2a1-71f9-ba88-ae89c5791044.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Country Hollow Apartments logo",
    "public_id": "019cfb3e-a2a1-71f9-ba88-ae89c5791044",
    "storage_key": "property/6767906449165598/019cfb3e-a2a1-71f9-ba88-ae89c5791044.webp",
    "width": 210,
    "height": 122
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3e-aefd-71cd-ab32-ff50e2eee6e0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Country Hollow Apartments logo",
    "public_id": "019cfb3e-aefd-71cd-ab32-ff50e2eee6e0",
    "storage_key": "property/6767906449165598/019cfb3e-aefd-71cd-ab32-ff50e2eee6e0.webp",
    "width": 210,
    "height": 122
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#324d58",
  "property_secondary_color": "#ab9989",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "500 - 900",
  "property_sqft_min": "500",
  "property_sqft_max": "900",
  "property_price_range": "769 - 1009",
  "property_price_min": "769",
  "property_price_max": "1009",
  "property_available_units": 12,
  "property_facebook_url": "https://m.facebook.com/CountryHollowTulsa/photos/d41d8cd9/1767365657434949/",
  "property_instagram_url": "https://www.instagram.com/countryhollowtulsa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJJZomLjmStocRkP0AhgHzRQk",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/country-hollow-apartments-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@countryhollowapts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Country Hollow Apartments",
  "property_home_romance_title": "Experience Love at First Sight with Your New Apartment Home",
  "property_home_amenities_blurb": "Experience the charm of Country Hollow Apartments in Tulsa, OK, where modern living meets comfort. Choose from stylish studio, one, or two-bedroom apartments, complete with oversized closets and picturesque views. Enjoy our exceptional amenities, including a refreshing pool, fitness center, and scenic walking trails—your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Country Hollow Apartments in the heart of Tulsa, OK, where comfort meets style. Choose from our thoughtfully designed studio, one-bedroom, and two-bedroom layouts, each crafted for modern living. Browse our available apartment homes today and uncover the ideal floor plan that complements your lifestyle.",
  "property_home_gallery_blurb": "At Country Hollow Apartments in Tulsa, OK, each spacious studio, one, and two-bedroom layout invites comfort and style. Enjoy amenities like a refreshing pool, fitness center, and scenic views, all while being steps away from LaFortune Park. Picture yourself living here, where convenience meets tranquility!",
  "property_home_neighborhood_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, our vibrant neighborhood invites you to enjoy local favorites and unique points of interest. With one and two-bedroom floor plans tailored for comfortable living, you’ll love the community vibe just outside your door. Experience the perfect blend of home and leisure!",
  "property_home_reviews_blurb": "At Country Hollow Apartments in Tulsa, the essence of home and community resonates beautifully. One resident shares, \"My cozy home is a perfect representation of who I am,\" highlighting our spacious interiors and inviting ambiance. With attentive management and swift maintenance, your ideal lifestyle awaits. Join us and see what our residents have to say!",
  "property_neighborhood_blurb": "At Country Hollow Apartments in Tulsa, OK, education and community thrive with top-rated schools just around the corner, including Jenks West Intermediate and Jenks High School. Discover a vibrant neighborhood rich in opportunities, and see what local favorites await you near your new home. Embrace convenient living today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, indulge in a lifestyle rich with amenities! Relax by the pool, stay active in the fitness center, or savor BBQs in our picnic area. With spacious one and two-bedroom floor plans, enjoy modern comforts alongside scenic walking and biking trails. Your perfect home awaits!",
  "property_applynow_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, your ideal living space awaits with spacious one and two-bedroom floor plans. Enjoy a refreshing dip in the pool, energize in the fitness center, or unwind at the picnic area. Find your new home and lease online today!",
  "property_contactus_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, you'll find thoughtfully designed one and two-bedroom floor plans that cater to your unique lifestyle. Our spacious layouts invite comfort and creativity. Have questions? Reach out to our leasing team today and let us help you find your perfect home in this charming community!",
  "property_faqs_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, we understand that choosing the perfect home is essential. Whether you seek a cozy one-bedroom sanctuary or a spacious two-bedroom retreat, our diverse floor plans cater to your lifestyle. Dive into our FAQs for answers to your queries and elevate your living experience!",
  "property_floorplans_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, your ideal home awaits. Choose from spacious one or two-bedroom floor plans designed for comfort and style. Each layout is crafted to enhance your living experience. Browse our available apartment homes today and let your next chapter begin!",
  "property_gallery_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, luxurious living meets everyday convenience. Imagine basking by the sparkling pool or enjoying fresh air on your private balcony. With a variety of floor plans and amenities like a fitness center, tennis court, and walking trails, picture yourself calling this vibrant community home!",
  "property_interactivemap_blurb": "At Country Hollow Apartments in Tulsa, indulge in a lifestyle filled with comfort and convenience. Choose from spacious one- or two-bedroom floor plans featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and scenic walking trails. Unearth your ideal living space using our interactive community map today!",
  "property_pets_blurb": "Nestled in the heart of Tulsa, Country Hollow Apartments offers a tranquil retreat with modern living spaces and scenic landscaping. Enjoy the freedom of pet-friendly apartments, perfect for furry companions. Experience a vibrant community where comfort meets convenience—your ideal home awaits amid the charm of Oklahoma's countryside.",
  "property_referafriend_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, our inviting one and two-bedroom floor plans offer the perfect backdrop for vibrant living. When you share this experience with friends, you create a community that feels like home. Refer a friend today—great friends make great neighbors!",
  "property_residentaccess_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, step into your ideal home with our thoughtfully designed one- and two-bedroom floor plans. Enjoy seamless living with easy access to your resident portal for rent payments, maintenance requests, and beyond—everything you need at your fingertips! ",
  "property_reviews_blurb": "At Country Hollow Apartments in Tulsa, OK, residents describe their homes as cozy reflections of their personalities, complete with inviting spaces and well-kept amenities. One happy tenant shares, \"Everything is as I dream,\" highlighting the balance of comfort and creativity. Read more to see what our residents have to say about living in our community!",
  "property_created_at": "1753982382008",
  "property_scheduletour_blurb": "At Country Hollow Apartments in Tulsa, Oklahoma, your next home awaits in our thoughtfully designed one and two-bedroom floor plans. Ready to envision your future? Schedule a tour today and hear firsthand from our residents about the vibrant lifestyle that makes our community truly exceptional! ",
  "property_thankyou_blurb": "Thank you for reaching out to Country Hollow Apartments in Tulsa, Oklahoma! With our inviting one and two-bedroom floor plans, your ideal home is just a step away. Our team will connect with you soon to help you take the next step towards finding your perfect apartment oasis.",
  "property_virtualtours_blurb": "Experience the charm of Country Hollow Apartments in Tulsa, Oklahoma! With thoughtfully designed one and two-bedroom floor plans, your perfect home awaits. Uncover your future lifestyle and immerse yourself in our inviting community. Ready to see it all? Take a virtual tour today and envision your new beginning!",
  "property_copyright": "2025 All Rights Reserved. Country Hollow Apartments",
  "property_seo_title_home": "Country Hollow Apartments | Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Welcome to Country Hollow Apartments in Tulsa! Enjoy modern one and two-bedroom layouts, resort-style amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Studio - 2 Apartments in Tulsa, Oklahoma",
  "property_seo_description_floorplans": "Discover your ideal living space at Country Hollow Apartments in Tulsa! Browse unique one and two-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Country Hollow Apartments in Tulsa! Enjoy a sparkling pool, fitness center, tennis courts, and spacious layouts designed for comfort.",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "\"Picture your life at Country Hollow Apartments in Tulsa! Choose from spacious one- and two-bedroom floor plans with vibrant amenities, including a pool, clubhouse, and trails!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Country Hollow Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Country Hollow Apartments in Tulsa! Experience our stunning one and two-bedroom designs through a virtual tour. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Country Hollow Apartments Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Country Hollow Apartments in Tulsa! Check out our interactive map for spacious floor plans, top-notch amenities, and more.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Country Hollow Apartments in Tulsa, Oklahoma! Dive into local gems and attractions just steps from your door—your ideal neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | Country Hollow Apartments",
  "property_seo_description_contact": "Experience comfort at Country Hollow Apartments in Tulsa. Choose from our one or two-bedroom floor plans. Questions? Our leasing team is ready to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Answer your burning questions and learn about Country Hollow Apartments in Tulsa. From amenities to floor plans, we've got the info you need!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Experience life at Country Hollow Apartments in Tulsa, where comfort meets community. Check out our residents' reviews and see why our apartments feel like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Live your best life at Country Hollow Apartments in Tulsa! Choose from stylish one or two-bedroom floor plans and enjoy top-notch amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Country Hollow Apartments",
  "property_seo_description_residentaccess": "\"Log in to Country Hollow Apartments' resident portal for easy rent payments, maintenance requests, and community updates. Your comfort, just a click away!\"",
  "property_seo_title_referafriend": "Refer A Friend | Country Hollow Apartments",
  "property_seo_description_referafriend": "Refer a friend to Country Hollow Apartments in Tulsa! Great neighbors make great memories—share the comfort of your community today and enjoy exclusive rewards!",
  "property_seo_title_scheduletour": "Schedule a Tour | Country Hollow Apartments",
  "property_seo_description_scheduletour": "Join us at Country Hollow Apartments in Tulsa! Experience modern living and serene surroundings. Schedule your personalized tour today and find your perfect home!",
  "property_seo_title_privacy": "Privacy Policy | Country Hollow Apartments",
  "property_seo_description_privacy": "Protecting your peace of mind at Country Hollow Apartments. Dive into our privacy practices and see how we keep your information safe. Read our policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Country Hollow Apartments",
  "property_seo_description_accessibility": "Experience digital inclusion at Country Hollow Apartments in Tulsa. Our commitment to accessibility ensures everyone feels at home. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Country Hollow Apartments",
  "property_seo_description_sitemap": "Uncover the charm of Country Hollow Apartments in Tulsa. Check our sitemap for a seamless journey to your dream home in a vibrant community!",
  "property_seo_title_thankyou": "Thank You | Country Hollow Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Country Hollow Apartments! Our team is excited to help you find your perfect Tulsa home. Stay tuned for a quick response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865123705",
  "amenities": [
    {
      "id": "ec_2098a3d3d7dc13e7166bc7cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396490",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de7ba53e66e56e8f9e808e09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396491",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9bc8ca28beda7cfcd9905b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396492",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_457f30636e3d7d35cc267563",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127498334",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb55ba3c1e8dbafb105bd806",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396493",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8e8043cca15b6ff508f0e9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396494",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c83c3bbd16015f1b7e852d88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396495",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff74b0354edf1da26f9f375c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127396496",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_761a74992b2496348f20c573",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "128017279",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43796fc4d58fb940f75bea58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "128042526",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f8aab065f482c64ab3ef1af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127397976",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_820f3fe37f5b86252adcc28e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127397977",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad12cb2588a2b34cb223293f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127397978",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_107edf0c582903dc0932ad38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127397979",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_11616a421423350f9feaa6b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127397980",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be2f8aa1ba3517d85d00b7eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "yardi",
      "external_id": "127397981",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0a8f66ed-d206-4e3b-953a-1822530109c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef82b-e798-760a-8da8-f926f4be5c71.webp",
      "image_media": {
        "alt_text": "Laundry room with stacked washers and dryers, and multiple washing machines.",
        "public_id": "019ef82b-e798-760a-8da8-f926f4be5c71",
        "storage_key": "property/6767906449165598/019ef82b-e798-760a-8da8-f926f4be5c71.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities available for residents, featuring multiple washers and dryers.",
      "link": "",
      "alt_text": "Laundry room with stacked washers and dryers, and multiple washing machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d749cd3d-1f9b-4c2d-9a61-4ffefdc28761",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef82b-e7fc-74ce-8ca1-cad7e7922cda.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washing machines and dryers.",
        "public_id": "019ef82b-e7fc-74ce-8ca1-cad7e7922cda",
        "storage_key": "property/6767906449165598/019ef82b-e7fc-74ce-8ca1-cad7e7922cda.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with multiple washers and dryers available for resident use.",
      "link": "",
      "alt_text": "Laundry room with multiple washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93e9b21a-969a-4fab-be0d-ca53c3b7cdfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-d0c7-737f-99f6-390e31fee220.webp",
      "image_media": {
        "alt_text": "Country Hollow apartment complex monument sign with landscaping and building exterior in background.",
        "public_id": "019ef541-d0c7-737f-99f6-390e31fee220",
        "storage_key": "property/6767906449165598/019ef541-d0c7-737f-99f6-390e31fee220.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to Country Hollow apartments, featuring a prominent monument sign, lush landscaping, and well-maintained building exteriors.",
      "link": "",
      "alt_text": "Country Hollow apartment complex monument sign with landscaping and building exterior in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21dfc38b-2b2f-4d96-910b-2f3b5c949486",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-ce76-7213-bf01-32ac1e287913.webp",
      "image_media": {
        "alt_text": "Exterior of an apartment building with a stone accent wall and balconies.",
        "public_id": "019ef541-ce76-7213-bf01-32ac1e287913",
        "storage_key": "property/6767906449165598/019ef541-ce76-7213-bf01-32ac1e287913.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The exterior of the apartment building showcases a mix of stone and siding, with balconies and lush green landscaping.",
      "link": "",
      "alt_text": "Exterior of an apartment building with a stone accent wall and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4aaa60da-6b2b-4e95-af08-9f691fc1ea6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-cad1-71ef-8b6b-88cbaed0246c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building exterior with manicured lawn.",
        "public_id": "019ef541-cad1-71ef-8b6b-88cbaed0246c",
        "storage_key": "property/6767906449165598/019ef541-cad1-71ef-8b6b-88cbaed0246c.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Charming apartment building exterior with stone and siding accents, surrounded by lush green landscaping and mature trees.",
      "link": "",
      "alt_text": "Exterior view of apartment building exterior with manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dfdc2874-da92-41c6-aeaf-47f014667bb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-b7a2-716a-b181-43b7ee7122e9.webp",
      "image_media": {
        "alt_text": "Apartment buildings with large green lawn and mature trees.",
        "public_id": "019ef541-b7a2-716a-b181-43b7ee7122e9",
        "storage_key": "property/6767906449165598/019ef541-b7a2-716a-b181-43b7ee7122e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious grounds with lush green grass and mature trees provide a serene setting for these apartment buildings.",
      "link": "",
      "alt_text": "Apartment buildings with large green lawn and mature trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_19151dce-c721-43da-8224-8d0c9d9b9c54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-abd9-70fb-ac9a-bcccc352ac21.webp",
      "image_media": {
        "alt_text": "Entrance to a fenced-in dog park with a sign that says 'Bark Park' and posted rules.",
        "public_id": "019ef541-abd9-70fb-ac9a-bcccc352ac21",
        "storage_key": "property/6767906449165598/019ef541-abd9-70fb-ac9a-bcccc352ac21.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our community's dedicated dog park, 'Canine Hollow,' a safe and fun space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Entrance to a fenced-in dog park with a sign that says 'Bark Park' and posted rules.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b9bb81a-b4cf-4282-8266-e046285d9be9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-b0cc-70cb-a172-6519af794be5.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment and benches under a blue sky.",
        "public_id": "019ef541-b0cc-70cb-a172-6519af794be5",
        "storage_key": "property/6767906449165598/019ef541-b0cc-70cb-a172-6519af794be5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our community dog park features agility equipment and comfortable seating, providing a safe and fun space for your furry friends to play.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment and benches under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28b0d000-509f-4525-a1b4-d4d38840548e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-8c34-7353-b796-5e256bb8b977.webp",
      "image_media": {
        "alt_text": "Exterior view of the leasing center building with a modern architectural design.",
        "public_id": "019ef541-8c34-7353-b796-5e256bb8b977",
        "storage_key": "property/6767906449165598/019ef541-8c34-7353-b796-5e256bb8b977.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing center, where our team is ready to assist you with finding your perfect home. Explore our community amenities and features.",
      "link": "",
      "alt_text": "Exterior view of the leasing center building with a modern architectural design.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_338fa6cd-b916-461e-9e99-33919c1b3b40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-a81f-70fd-b648-dbab52599d2b.webp",
      "image_media": {
        "alt_text": "Exterior building view with parking lot and disabled parking spaces.",
        "public_id": "019ef541-a81f-70fd-b648-dbab52599d2b",
        "storage_key": "property/6767906449165598/019ef541-a81f-70fd-b648-dbab52599d2b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the apartment building exterior, featuring a parking lot with designated disabled parking spots, grassy areas, and external staircases.",
      "link": "",
      "alt_text": "Exterior building view with parking lot and disabled parking spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c8b7de0-9f76-4249-8adb-116051a1a981",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-9881-76a9-9acc-e55ef2af39b5.webp",
      "image_media": {
        "alt_text": "Apartment buildings with pathways and greenery.",
        "public_id": "019ef541-9881-76a9-9acc-e55ef2af39b5",
        "storage_key": "property/6767906449165598/019ef541-9881-76a9-9acc-e55ef2af39b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Well-maintained pathways wind through the lush green courtyards between apartment buildings.",
      "link": "",
      "alt_text": "Apartment buildings with pathways and greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74a9b982-1798-4f6b-8874-1090512fad57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-8f41-73da-a46d-b3046d9a20d6.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing center building with landscaping and signage.",
        "public_id": "019ef541-8f41-73da-a46d-b3046d9a20d6",
        "storage_key": "property/6767906449165598/019ef541-8f41-73da-a46d-b3046d9a20d6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Welcome to the leasing center, the hub of our community. Enjoy the beautifully maintained grounds and convenient amenities.",
      "link": "",
      "alt_text": "Exterior of the leasing center building with landscaping and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60a76fe6-72d5-4751-a046-fb49a17dff92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-8f38-7159-9498-816c1d2bbffa.webp",
      "image_media": {
        "alt_text": "Country Hollow Leasing Office sign with an arrow.",
        "public_id": "019ef541-8f38-7159-9498-816c1d2bbffa",
        "storage_key": "property/6767906449165598/019ef541-8f38-7159-9498-816c1d2bbffa.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Welcome to Country Hollow, find our leasing office with this directional sign.",
      "link": "",
      "alt_text": "Country Hollow Leasing Office sign with an arrow.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1d4ed904-e604-42ec-98d4-2235bb61ccb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-5658-71af-a62b-94612f5c246f.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019ef541-5658-71af-a62b-94612f5c246f",
        "storage_key": "property/6767906449165598/019ef541-5658-71af-a62b-94612f5c246f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for a relaxing afternoon or a fun day with family and friends.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e58bffc-af4c-4918-8fe5-ffe6284a98bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-56ad-7656-9854-87e519aa33b3.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
        "public_id": "019ef541-56ad-7656-9854-87e519aa33b3",
        "storage_key": "property/6767906449165598/019ef541-56ad-7656-9854-87e519aa33b3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_46bfffc9-a4de-45af-a8fc-ac4bfacf867a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-5966-7487-854b-0ee32b483e2e.webp",
      "image_media": {
        "alt_text": "Tennis court with blue and tan colored courts and a net.",
        "public_id": "019ef541-5966-7487-854b-0ee32b483e2e",
        "storage_key": "property/6767906449165598/019ef541-5966-7487-854b-0ee32b483e2e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of tennis on our well-maintained courts, perfect for residents looking to stay active and have fun.",
      "link": "",
      "alt_text": "Tennis court with blue and tan colored courts and a net.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e78e4e00-227e-4de0-a1bf-cf293b2ea91f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-5651-765e-bf2f-dbcae9bf2506.webp",
      "image_media": {
        "alt_text": "Tennis and pickleball courts with nets and surrounding greenery.",
        "public_id": "019ef541-5651-765e-bf2f-dbcae9bf2506",
        "storage_key": "property/6767906449165598/019ef541-5651-765e-bf2f-dbcae9bf2506.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on our tennis and pickleball courts, perfect for friendly matches or a quick game.",
      "link": "",
      "alt_text": "Tennis and pickleball courts with nets and surrounding greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e719e13b-8ea2-4316-9273-797cabfb4f34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-5a2b-77e9-9c41-8512a182e411.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a dark-colored building in the background.",
        "public_id": "019ef541-5a2b-77e9-9c41-8512a182e411",
        "storage_key": "property/6767906449165598/019ef541-5a2b-77e9-9c41-8512a182e411.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a dark-colored building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7aa15f8e-46e1-47ce-99ae-d91b17ca3da7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-58dd-7555-81b0-c1092bc9a631.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019ef541-58dd-7555-81b0-c1092bc9a631",
        "storage_key": "property/6767906449165598/019ef541-58dd-7555-81b0-c1092bc9a631.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush trees and comfortable lounge chairs. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc993920-7232-4945-b7c0-f89390cc0d52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef541-5778-7008-b6a2-e8bd2ec80c6f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building with a covered patio.",
        "public_id": "019ef541-5778-7008-b6a2-e8bd2ec80c6f",
        "storage_key": "property/6767906449165598/019ef541-5778-7008-b6a2-e8bd2ec80c6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by lush trees and comfortable lounge seating.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building with a covered patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4536170c-184a-42d0-9d6b-b8fd25d38801",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef540-075c-7669-a8a5-e12a4f53aa5a.webp",
      "image_media": {
        "alt_text": "Interior view of the lobby with a coffee bar, seating area, and hallway.",
        "public_id": "019ef540-075c-7669-a8a5-e12a4f53aa5a",
        "storage_key": "property/6767906449165598/019ef540-075c-7669-a8a5-e12a4f53aa5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our community's stylish lobby, featuring a convenient coffee bar, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Interior view of the lobby with a coffee bar, seating area, and hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_80879e56-98e5-41f7-a593-1e9c7145dfb4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019ef540-0775-749b-a9c7-9ed6c3cfddce.webp",
      "image_media": {
        "alt_text": "Reception desk with dual monitors, leather chairs, and a blue rug in a common area with vaulted ceilings.",
        "public_id": "019ef540-0775-749b-a9c7-9ed6c3cfddce",
        "storage_key": "property/6767906449165598/019ef540-0775-749b-a9c7-9ed6c3cfddce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our modern common area, featuring a stylish reception desk, comfortable seating, and impressive vaulted ceilings with exposed beams, perfect for residents to relax and connect.",
      "link": "",
      "alt_text": "Reception desk with dual monitors, leather chairs, and a blue rug in a common area with vaulted ceilings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7d370b0-49b1-4cec-bf38-2ee14844cd7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae6-11fb-7125-b1b5-7e359372d9df.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machine.",
        "public_id": "019dbae6-11fb-7125-b1b5-7e359372d9df",
        "storage_key": "property/6767906449165598/019dbae6-11fb-7125-b1b5-7e359372d9df.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay active in our community fitness center, equipped with modern cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1cb8ea67-3d4b-492e-9c34-b72721865168",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019dbae6-144e-76ad-b2ee-fe716f88e073.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, and weight machine.",
        "public_id": "019dbae6-144e-76ad-b2ee-fe716f88e073",
        "storage_key": "property/6767906449165598/019dbae6-144e-76ad-b2ee-fe716f88e073.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Our community fitness center features modern cardio machines and a strength training station for your workout needs.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_881cd781-d2d5-4e17-8c08-4b6f9bfb2979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves tasty steaks, ribs, and fried pickles, and the rolls are delicious. They also highlight the affordable prices, lively atmosphere, and attentive service.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-bf1b-70fb-8652-9af4a81a4ff2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf1b-70fb-8652-9af4a81a4ff2",
        "storage_key": "property/6767906449165598/019d2708-bf1b-70fb-8652-9af4a81a4ff2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6d9-7488-95de-5af956437797",
        "storage_key": "property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_430a6975-965b-49a7-8247-82cb09a6c532",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a wide variety of delicious food, including pasta, burgers, and cheesecake. They also highlight the attentive and knowledgeable service, and the beautiful, bold decor.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-bf22-77ee-a91e-528751d35bd8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf22-77ee-a91e-528751d35bd8",
        "storage_key": "property/6767906449165598/019d2708-bf22-77ee-a91e-528751d35bd8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6d9-7488-95de-5af956437797",
        "storage_key": "property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9c56428b-c520-445d-96bd-aae1c28cda7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, dipping sauce, and sweet tea. They highlight the fast service, friendly staff, and clean atmosphere. They also like the generous portions and fair prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-bf0f-7130-a245-03f81de53eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf0f-7130-a245-03f81de53eae",
        "storage_key": "property/6767906449165598/019d2708-bf0f-7130-a245-03f81de53eae.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6d9-7488-95de-5af956437797",
        "storage_key": "property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_6142619a-b2d7-4be0-8f33-3ac56f104815",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves fresh and delicious chicken sandwiches and chicken strips. They also highlight the friendly and polite staff, and the quick drive-thru service.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-bf11-733a-b662-027905b29db0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bf11-733a-b662-027905b29db0",
        "storage_key": "property/6767906449165598/019d2708-bf11-733a-b662-027905b29db0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6d9-7488-95de-5af956437797",
        "storage_key": "property/6767906449165598/019d2708-f6d9-7488-95de-5af956437797.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c09fa3c4-64a7-4e3e-9e49-d097a379d4d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "2-story enclosed mall with many chain stores & boutiques, plus a kids’ play area & a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including a Scheels with a Ferris wheel, and a good food court. They also highlight the clean and safe atmosphere, and the friendly and helpful staff.\n\nOther reviews mention the escalators can be out of service.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6cb-7710-a641-14e95e3106b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6cb-7710-a641-14e95e3106b1",
        "storage_key": "property/6767906449165598/019d2708-f6cb-7710-a641-14e95e3106b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0673fdac-0c23-4a3b-a681-4b8e98b9fbff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores, including clothing, shoes, and home goods. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-c512-731a-8a63-e5e025f81d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c512-731a-8a63-e5e025f81d5b",
        "storage_key": "property/6767906449165598/019d2708-c512-731a-8a63-e5e025f81d5b.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6cb-7710-a641-14e95e3106b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6cb-7710-a641-14e95e3106b1",
        "storage_key": "property/6767906449165598/019d2708-f6cb-7710-a641-14e95e3106b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7aeaa7ea-5595-43e9-9e49-a878be2ec11f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3702 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique items, fresh flowers, and delicious snacks. They highlight the reasonable prices and the fun, exciting shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-c4cc-7359-bb5a-abd635232452.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c4cc-7359-bb5a-abd635232452",
        "storage_key": "property/6767906449165598/019d2708-c4cc-7359-bb5a-abd635232452.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/tulsa/460/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583892652892204013&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "36.1096067",
      "poi_longitude": "-95.975934",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-712-9768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f706-739c-87b4-aaff0ed90ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f706-739c-87b4-aaff0ed90ebe",
        "storage_key": "property/6767906449165598/019d2708-f706-739c-87b4-aaff0ed90ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxY2lOTtocR7autsmWug7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_90963e1c-e9b8-465d-9aca-d92c1e3974ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meat, and bulk items, including a large selection of candies, spices, and coffee. They highlight the unbeatable prices, especially on chicken and pork, and the convenient 24-hour availability. They also like the clean and well-stocked store, and the friendly and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-c51d-76a5-b8a7-8bf2064c9c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c51d-76a5-b8a7-8bf2064c9c5f",
        "storage_key": "property/6767906449165598/019d2708-c51d-76a5-b8a7-8bf2064c9c5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f706-739c-87b4-aaff0ed90ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f706-739c-87b4-aaff0ed90ebe",
        "storage_key": "property/6767906449165598/019d2708-f706-739c-87b4-aaff0ed90ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_421ce24a-a943-4f95-b7e4-5c35af981c34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Mid-range chain stores & specialty shops, plus familiar fast food, in a refined strip-mall format.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including retail, food, and services, and has convenient parking. They highlight the easy access, convenient location, and the ability to find everything in one place. They also like the clean and safe environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-c607-75c3-b5a9-915b6e7f5526.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c607-75c3-b5a9-915b6e7f5526",
        "storage_key": "property/6767906449165598/019d2708-c607-75c3-b5a9-915b6e7f5526.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6cb-7710-a641-14e95e3106b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6cb-7710-a641-14e95e3106b1",
        "storage_key": "property/6767906449165598/019d2708-f6cb-7710-a641-14e95e3106b1.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2009af73-2a8f-4ac4-8891-036143c5405c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-cd55-7455-b134-6db795ea3796.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cd55-7455-b134-6db795ea3796",
        "storage_key": "property/6767906449165598/019d2708-cd55-7455-b134-6db795ea3796.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6c3-77d8-aba1-2514d27b1c63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6c3-77d8-aba1-2514d27b1c63",
        "storage_key": "property/6767906449165598/019d2708-f6c3-77d8-aba1-2514d27b1c63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_46635415-98fc-409a-940d-d14a07dd11fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-cd8a-77a8-aa2b-421680f19975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cd8a-77a8-aa2b-421680f19975",
        "storage_key": "property/6767906449165598/019d2708-cd8a-77a8-aa2b-421680f19975.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6c3-77d8-aba1-2514d27b1c63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6c3-77d8-aba1-2514d27b1c63",
        "storage_key": "property/6767906449165598/019d2708-f6c3-77d8-aba1-2514d27b1c63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_38593c36-5d12-4385-820c-1962b00cb17f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide variety of books and engaging programs for all ages, including story time for infants and toddlers. They highlight the spacious and beautiful environment, with comfortable seating and study rooms, and the helpful staff. They also like the dedicated kids' area with board books and activities, and the clean bathrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-cd83-72f7-a286-e49dfffb9258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cd83-72f7-a286-e49dfffb9258",
        "storage_key": "property/6767906449165598/019d2708-cd83-72f7-a286-e49dfffb9258.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f6c3-77d8-aba1-2514d27b1c63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f6c3-77d8-aba1-2514d27b1c63",
        "storage_key": "property/6767906449165598/019d2708-f6c3-77d8-aba1-2514d27b1c63.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_ec99a931-c72d-4b89-9aa3-e344d1159183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of aquatic animals, including sharks, sea turtles, and jellyfish, and provides interactive experiences like touch tanks and feeding opportunities. They highlight the informative signage, the amazing shark tunnel, and the kid-friendly atmosphere with tunnels and a playground. They also like the friendly and helpful staff.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_80c996a4-cb4b-484c-9362-4e17efcfe711",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Global collection of fine & decorative art in an ornate Italian Renaissance-style mansion & gardens.",
      "poi_long_description": "People say this museum offers a diverse collection of art, including traditional and modern pieces, and a beautiful Samurai exhibit. They highlight the stunning architecture, the well-maintained gardens and grounds, and the serene views. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-cfd0-761c-967f-1b36617a5dc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cfd0-761c-967f-1b36617a5dc8",
        "storage_key": "property/6767906449165598/019d2708-cfd0-761c-967f-1b36617a5dc8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-facf-703b-bf09-9bda3061f097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-facf-703b-bf09-9bda3061f097",
        "storage_key": "property/6767906449165598/019d2708-facf-703b-bf09-9bda3061f097.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b3fd1c28-4fb8-4652-bcf5-ec8fab1da0ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Discovery Lab",
      "poi_type": "Entertainment",
      "poi_address": "3123 Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Interactive kids' science museum & play center offering educational exhibits & DIY crafts.",
      "poi_long_description": "People say this children's museum offers a wide variety of interactive and educational exhibits, including a ball space, maker spaces, and a paper airplane section. They highlight the fun, hands-on learning experience, and the value of a membership for frequent visits. They also like the friendly and courteous staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-d2cb-70be-9395-105289b50a36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d2cb-70be-9395-105289b50a36",
        "storage_key": "property/6767906449165598/019d2708-d2cb-70be-9395-105289b50a36.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverylab.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13384989011052284106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "discovery-lab",
      "poi_latitude": "36.1180586",
      "poi_longitude": "-95.9841454",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-295-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-facf-703b-bf09-9bda3061f097.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-facf-703b-bf09-9bda3061f097",
        "storage_key": "property/6767906449165598/019d2708-facf-703b-bf09-9bda3061f097.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi01Lj3vrtocRykhHvpYIwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c6143f88-9584-4314-a3dc-106181e16386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, basketball, and concessions. They highlight the clean facility, the safe environment with staff at each slide, and the fun experience for kids and adults. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-d2d7-737b-a48c-a9b715a8f95d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d2d7-737b-a48c-a9b715a8f95d",
        "storage_key": "property/6767906449165598/019d2708-d2d7-737b-a48c-a9b715a8f95d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_a829b091-9651-4363-8261-3838f98c6205",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_long_description": "People say this arena offers comfortable seating and good views for events, including concerts and sporting events. They highlight the venue is clean, family-friendly, and has plenty of parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-d565-7528-8cbf-13895c42ed72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d565-7528-8cbf-13895c42ed72",
        "storage_key": "property/6767906449165598/019d2708-d565-7528-8cbf-13895c42ed72.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_1e5d73ae-fe5e-4c84-acc8-f45f6f54dadf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "People say this gym offers a variety of workout equipment, classes, and pool programs, and has a playroom for children.\n\nOther reviews mention the facilities can be crowded and the management can be unresponsive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-d71f-710f-b417-824b4ca12a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d71f-710f-b417-824b4ca12a8e",
        "storage_key": "property/6767906449165598/019d2708-d71f-710f-b417-824b4ca12a8e.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_18936e3a-20fc-4c58-9630-c914987f8760",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "Some gym goers say this gym offers a wide variety of well-maintained equipment, excellent personal trainers, and a great selection of fitness classes.\n\nOther reviews mention the gym can be crowded and management can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-da9b-7443-a78b-34f1cb08fe99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-da9b-7443-a78b-34f1cb08fe99",
        "storage_key": "property/6767906449165598/019d2708-da9b-7443-a78b-34f1cb08fe99.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_06e4db5d-bbe8-4cba-b118-2225e6db2eb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-d8f4-765a-bcdc-710f391612ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d8f4-765a-bcdc-710f391612ec",
        "storage_key": "property/6767906449165598/019d2708-d8f4-765a-bcdc-710f391612ec.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_fe2919a9-867e-4e77-9d3b-3bb558ceacd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-dc3b-74b0-81c3-65ece29efa8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dc3b-74b0-81c3-65ece29efa8e",
        "storage_key": "property/6767906449165598/019d2708-dc3b-74b0-81c3-65ece29efa8e.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_74ee80d9-c1c4-4a48-afd0-f2626aa36595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "People say this gym offers a clean and comfortable environment with friendly and helpful staff. They also highlight the welcoming and judgement-free atmosphere, making it a great place for all fitness levels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-df9d-7529-975d-1aa5bf2496f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-df9d-7529-975d-1aa5bf2496f5",
        "storage_key": "property/6767906449165598/019d2708-df9d-7529-975d-1aa5bf2496f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1d7f276b-cf22-4b3d-b074-6fd3df0f2678",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7990 E 51st St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, amenities, and classes, including yoga, HIIT, and aqua classes. They also highlight the motivating atmosphere, the knowledgeable and supportive instructors, and the friendly community.\n\nSome reviews mention there can be hidden fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-deb6-751c-9d1c-1c1f01dd14cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-deb6-751c-9d1c-1c1f01dd14cc",
        "storage_key": "property/6767906449165598/019d2708-deb6-751c-9d1c-1c1f01dd14cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/tulsa/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684131092404226149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "36.0885483",
      "poi_longitude": "-95.8878289",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-984-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXRVgW-NtocRZcjZx1JfJqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_80ba3368-d161-474a-b496-38aed89245ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and a sauna. They highlight the clean facilities, spacious layout, and motivating atmosphere. They also like the friendly, knowledgeable, and helpful staff, and the range of fitness classes available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e06c-765a-b487-fe14142b34a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e06c-765a-b487-fe14142b34a9",
        "storage_key": "property/6767906449165598/019d2708-e06c-765a-b487-fe14142b34a9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1bfee58c-d04d-471d-bc88-0ef41cd64498",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e1c4-7684-b10a-febaf2e1988e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e1c4-7684-b10a-febaf2e1988e",
        "storage_key": "property/6767906449165598/019d2708-e1c4-7684-b10a-febaf2e1988e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-faf0-7159-9242-461b091dacf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-faf0-7159-9242-461b091dacf6",
        "storage_key": "property/6767906449165598/019d2708-faf0-7159-9242-461b091dacf6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_03239d36-3332-4f26-ab90-74f236db6664",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Saint Francis Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "10501 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e342-766f-a38d-95c89614d5c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e342-766f-a38d-95c89614d5c4",
        "storage_key": "property/6767906449165598/019d2708-e342-766f-a38d-95c89614d5c4.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406794313894727694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital-south",
      "poi_latitude": "36.0333434",
      "poi_longitude": "-95.8576667",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-307-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-faf0-7159-9242-461b091dacf6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-faf0-7159-9242-461b091dacf6",
        "storage_key": "property/6767906449165598/019d2708-faf0-7159-9242-461b091dacf6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXaxi3-OtocRDhBgtecRcv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_e4745f1c-4732-4124-a821-5e272217dffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Riverfront park featuring an adventure playground, a sensory garden, a picnic area, eateries & more.",
      "poi_long_description": "People say this park offers a variety of playgrounds, walking trails, water features, and a boathouse with kayaking and paddle boating. They highlight the free admission, family-friendly atmosphere, and peaceful vibe. They also like the clean restrooms and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e519-74e5-b18a-622015e7e70a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e519-74e5-b18a-622015e7e70a",
        "storage_key": "property/6767906449165598/019d2708-e519-74e5-b18a-622015e7e70a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad9-7289-a17d-07fd5380117c",
        "storage_key": "property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ae2b2f6f-92f2-45a4-93c4-553f3bb10b9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Large city park with ample facilities including sports fields & courts, a pool, playgrounds & golf.",
      "poi_long_description": "Visitors say this park offers a scenic walking trail, playgrounds, and a well-maintained golf course with helpful instructors. They also highlight the family-friendly atmosphere, abundance of shade, and the presence of public restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e6b4-72ca-9ffa-d0fc100b14cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e6b4-72ca-9ffa-d0fc100b14cc",
        "storage_key": "property/6767906449165598/019d2708-e6b4-72ca-9ffa-d0fc100b14cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad9-7289-a17d-07fd5380117c",
        "storage_key": "property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4889e561-f20e-4192-b5c7-cb9bc3775980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Large space featuring a dog park & small pond, plus trails for walking & biking.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e7f1-716c-9dfc-2a56c7ea43c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e7f1-716c-9dfc-2a56c7ea43c1",
        "storage_key": "property/6767906449165598/019d2708-e7f1-716c-9dfc-2a56c7ea43c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad9-7289-a17d-07fd5380117c",
        "storage_key": "property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1746f6f9-49ee-4742-94c2-8428c8e784b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Vast county park boasting picnic area & playgrounds, plus an 18-hole championship disc golf course.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, disc golf, hiking trails, and picnic areas. They highlight the spacious layout, clean facilities, and well-maintained grounds. They also like the shaded areas and the peaceful, natural atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-e92b-77a3-b173-94790c47879b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e92b-77a3-b173-94790c47879b",
        "storage_key": "property/6767906449165598/019d2708-e92b-77a3-b173-94790c47879b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad9-7289-a17d-07fd5380117c",
        "storage_key": "property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1e2a00ec-a954-4059-85d0-313cf67c3a48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Turkey Mountain",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6800 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Hilly, forested park featuring jogging, biking & horseback riding trails, plus restrooms.",
      "poi_long_description": "People say this park offers well-maintained trails suitable for hiking, biking, and running, with beautiful views of the city skyline and Arkansas River. They highlight the peaceful and refreshing atmosphere, perfect for connecting with nature and enjoying outdoor activities. They also like the new trail additions and upgrades, and the friendly community of fellow hikers and bikers. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-eb58-753e-88a2-ebf3d6000f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-eb58-753e-88a2-ebf3d6000f74",
        "storage_key": "property/6767906449165598/019d2708-eb58-753e-88a2-ebf3d6000f74.webp",
        "width": 576,
        "height": 1280
      },
      "poi_business_url": "https://www.riverparks.org/experience/turkey-mountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=1129856788357496640&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "turkey-mountain",
      "poi_latitude": "36.0648571",
      "poi_longitude": "-95.9934169",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-596-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad9-7289-a17d-07fd5380117c",
        "storage_key": "property/6767906449165598/019d2708-fad9-7289-a17d-07fd5380117c.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWFdbHyUtocRQL8cRcMOrg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6feb1609-1297-4321-bebf-e9db67177827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-ec73-77a9-80c6-58ad5106e220.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ec73-77a9-80c6-58ad5106e220",
        "storage_key": "property/6767906449165598/019d2708-ec73-77a9-80c6-58ad5106e220.webp",
        "width": 1280,
        "height": 1034
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-feb7-70fd-a06b-4e27111f422a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-feb7-70fd-a06b-4e27111f422a",
        "storage_key": "property/6767906449165598/019d2708-feb7-70fd-a06b-4e27111f422a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c016aff9-1c2c-453a-bcaf-f110da21e584",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-ed35-77de-b9d4-6aacd150ce6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ed35-77de-b9d4-6aacd150ce6e",
        "storage_key": "property/6767906449165598/019d2708-ed35-77de-b9d4-6aacd150ce6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-feb7-70fd-a06b-4e27111f422a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-feb7-70fd-a06b-4e27111f422a",
        "storage_key": "property/6767906449165598/019d2708-feb7-70fd-a06b-4e27111f422a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2fbabbb4-6ba2-45f6-82ab-ebb482ff776d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f088-7325-b722-14a3219ed17e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f088-7325-b722-14a3219ed17e",
        "storage_key": "property/6767906449165598/019d2708-f088-7325-b722-14a3219ed17e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0ff90fbe-5ccc-4c11-a8bf-12a7ad2ef0ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f04c-70c8-a1e2-a4a4502668b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f04c-70c8-a1e2-a4a4502668b2",
        "storage_key": "property/6767906449165598/019d2708-f04c-70c8-a1e2-a4a4502668b2.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_88859765-acff-41b6-8527-eacee5907616",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-f289-759c-b679-d582d8ef0a23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f289-759c-b679-d582d8ef0a23",
        "storage_key": "property/6767906449165598/019d2708-f289-759c-b679-d582d8ef0a23.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ab84b889-d241-4f0b-8635-c3b0b1456a40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5042b844-91cf-4957-bd7d-2a6cf02d1d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Corporate Woods BUSINESS COMPLEX",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4500 S 129th E Ave, Tulsa, OK 74134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9788116077842907967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "corporate-woods-business-complex",
      "poi_latitude": "36.09808270000001",
      "poi_longitude": "-95.8398889",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fad8-70d9-b262-2b8cf99b2c58",
        "storage_key": "property/6767906449165598/019d2708-fad8-70d9-b262-2b8cf99b2c58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwPveuqMtocRP8MdkLZf1oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_02aeff96-78e5-4dd7-a650-5aae67a6f04f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Jenks East Elementary School",
      "poi_type": "Education",
      "poi_address": "8925 S Harvard Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7666529671605862805&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-east-elementary-school",
      "poi_latitude": "36.033814",
      "poi_longitude": "-95.9378796",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-677b949aacac",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtXopIMyTtocRlUEPCB78ZGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_13586a9c-9e26-4835-be3e-d33bc9a7f64d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Jenks East Intermediate",
      "poi_type": "Education",
      "poi_address": "3933 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jenksps.org/o/east-intermediate",
      "poi_directions_map_url": "https://maps.google.com/?cid=15765709535319936513&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-east-intermediate",
      "poi_latitude": "36.03378319999999",
      "poi_longitude": "-95.9326473",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-677b949aacac",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy7xD5yiStocRAc67xEoNy9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2111ab0e-9bfc-462d-bbae-4e500ba65d68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Jenks Middle School",
      "poi_type": "Education",
      "poi_address": "3019 E 101st St S, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jenksps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14101611830866602126&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-middle-school",
      "poi_latitude": "36.0187568",
      "poi_longitude": "-95.9426735",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-677b949aacac",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJscJrOHiRtocRjug_Iz_9ssM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f22fb346-32b7-4f80-addf-cd1a92c33c91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Jenks High School",
      "poi_type": "Education",
      "poi_address": "205 E B St, Jenks, OK 74037, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-245f-768f-a1a3-f318e290a9bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-245f-768f-a1a3-f318e290a9bb",
        "storage_key": "property/6767906449165598/019d7912-245f-768f-a1a3-f318e290a9bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jenksps.org/o/high-school",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896344340347075511&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jenks-high-school",
      "poi_latitude": "36.0257108",
      "poi_longitude": "-95.9692903",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-299-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-677b949aacac",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ5df6ViRtocRt7thUDxP80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_d882c572-e2fa-4cf1-8c42-bc5df27578c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-2289-74bf-aeb9-521e29d26db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2289-74bf-aeb9-521e29d26db4",
        "storage_key": "property/6767906449165598/019d7912-2289-74bf-aeb9-521e29d26db4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-677b949aacac",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-677b949aacac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9efc4f14-5678-4442-b5d1-7823c9776cc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Fireside Grill",
      "poi_type": "Restaurants",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Relaxed, fireplace-equipped restaurant offering steaks, burgers and seafood.",
      "poi_long_description": "People say this restaurant serves delicious chicken fried steak, green beans, mashed potatoes, house salad, and fried shrimp. They also highlight the warm, friendly, and inviting atmosphere, and the attentive service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-2456-72bf-ab4f-8f49c8ad92a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2456-72bf-ab4f-8f49c8ad92a5",
        "storage_key": "property/6767906449165598/019d7912-2456-72bf-ab4f-8f49c8ad92a5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/dining-nightlife/fireside-grill/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5237525234653677423&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fireside-grill",
      "poi_latitude": "36.0411552",
      "poi_longitude": "-95.9630975",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f1-728a-93bc-37350a766c10",
        "storage_key": "property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUOrMOiTtocRb0etiXNtr0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_728ee747-ccd5-4245-9017-cd32696ffabd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Texas de Brazil - Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "7021 S Memorial Dr Ste 176, Tulsa, OK 74133, USA",
      "poi_short_description": "Upscale Brazilian eatery featuring all-you-can-eat grilled meat carved tableside & a salad bar.",
      "poi_long_description": "Upscale Brazilian eatery featuring all-you-can-eat grilled meat carved tableside & a salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-228d-75ba-97a1-4aea514e986b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-228d-75ba-97a1-4aea514e986b",
        "storage_key": "property/6767906449165598/019d7912-228d-75ba-97a1-4aea514e986b.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://texasdebrazil.com/locations/tulsa/?utm_source=gmb&utm_medium=yext&y_source=1_NDg4MzA3MTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18226415542484854114&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-de-brazil-tulsa",
      "poi_latitude": "36.0627542",
      "poi_longitude": "-95.8803523",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-921-7994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f1-728a-93bc-37350a766c10",
        "storage_key": "property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjQkYPpeNtocRYuV3Ql488fw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a7366959-cfe9-4000-854d-0ac4f9d3c208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Yokozuna Yale",
      "poi_type": "Restaurants",
      "poi_address": "9146 S Yale Ave #100, Tulsa, OK 74137, USA",
      "poi_short_description": "Modern eatery for creatively presented sushi, plus Asian-inspired dishes like fried rice.",
      "poi_long_description": "People say this sushi restaurant offers delicious miso soup and a flaming volcano roll. They also highlight the friendly and attentive service, and the positive and joyful vibe.\n\nSome reviews mention the sushi can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-2bb2-7015-8223-67d15b2dc2ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2bb2-7015-8223-67d15b2dc2ce",
        "storage_key": "property/6767906449165598/019d7912-2bb2-7015-8223-67d15b2dc2ce.webp",
        "width": 289,
        "height": 312
      },
      "poi_business_url": "http://www.yokozunasushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8849555864641643460&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "yokozuna-yale",
      "poi_latitude": "36.0298714",
      "poi_longitude": "-95.9233942",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-619-6271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f1-728a-93bc-37350a766c10",
        "storage_key": "property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4hxYyCStocRxKPwAyzwz3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_93750433-c070-4cb7-a48c-4f9aecf62820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "3915 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-2c03-71f8-a45d-542abf71f4f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2c03-71f8-a45d-542abf71f4f4",
        "storage_key": "property/6767906449165598/019d7912-2c03-71f8-a45d-542abf71f4f4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.starbucks.com/store-locator?map=36.154755,-95.87141,11z&place=3915%20S%20Peoria%20Ave,%20Tulsa,%20OK%2074105,%20USA",
      "poi_directions_map_url": "https://maps.google.com/?cid=10184904909249446769&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "36.1055243",
      "poi_longitude": "-95.9740299",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-747-9672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-6c22-716d-b20d-22bfcca64407.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-6c22-716d-b20d-22bfcca64407",
        "storage_key": "property/6767906449165598/019d7912-6c22-716d-b20d-22bfcca64407.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJkW3zR1CTtocRcQPykg0NWI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_38d9cf96-f09a-4bb9-85ef-184db4a43056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Jersey Mike's Subs",
      "poi_type": "Restaurants",
      "poi_address": "4785 E 91st St Suite F, Tulsa, OK 74137, USA",
      "poi_short_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_long_description": "People say this sandwich shop offers fresh and delicious subs with quality ingredients. They also highlight the friendly and welcoming staff, and the fast and thoughtful service.\n\nOther reviews mention orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-3834-76d0-836a-d6ff246d80d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3834-76d0-836a-d6ff246d80d1",
        "storage_key": "property/6767906449165598/019d7912-3834-76d0-836a-d6ff246d80d1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jerseymikes.com/23023/tulsa-ok?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=10740200246210011623&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jersey-mike-s-subs",
      "poi_latitude": "36.0323319",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-764-8201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f1-728a-93bc-37350a766c10",
        "storage_key": "property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKdVVJ0WTtocR5yHpSzjbDJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_3b6e18b0-b3a6-4efd-a98e-7d2dc01ca156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Upper Crust Wood Fired Pizza",
      "poi_type": "Restaurants",
      "poi_address": "9110 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Local pizzeria chain serving wood-fired pies, wine & cocktails in a Napa Valley–inspired setting.",
      "poi_long_description": "Diners say this pizza restaurant serves up delicious dill pizza and cheese bites, and they praise the exceptional customer service provided by the attentive staff. They also highlight the fair prices and the welcoming atmosphere, making it a great place to enjoy a meal.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-3382-701e-b5fc-45a65c81af05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3382-701e-b5fc-45a65c81af05",
        "storage_key": "property/6767906449165598/019d7912-3382-701e-b5fc-45a65c81af05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://ucpizza.com/locations/upper-crust-tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5701288916057361672&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "upper-crust-wood-fired-pizza",
      "poi_latitude": "36.0314459",
      "poi_longitude": "-95.9225334",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-728-7326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f1-728a-93bc-37350a766c10",
        "storage_key": "property/6767906449165598/019cfb3d-e2f1-728a-93bc-37350a766c10.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeS-YCCStocRCI14-w8MH08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f87f2ea0-6b53-48f2-8f94-b1dca46e6869",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10019 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide range of products, including home goods, electronics, and groceries. They also highlight the clean store, efficient self-checkout, and helpful employees.\n\nOther reviews mention the lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-358f-74f8-b460-72e765642e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-358f-74f8-b460-72e765642e93",
        "storage_key": "property/6767906449165598/019d7912-358f-74f8-b460-72e765642e93.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-south/2542",
      "poi_directions_map_url": "https://maps.google.com/?cid=16722350443478589485&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0190344",
      "poi_longitude": "-95.8836409",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-615-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-6242e5a430d7",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJC2SoWRCOtocRLSAjKSG5Eeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_cb80c956-7275-42b6-a77e-22618f541240",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "7362 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-3579-712b-b38d-d37334eac292.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3579-712b-b38d-d37334eac292",
        "storage_key": "property/6767906449165598/019d7912-3579-712b-b38d-d37334eac292.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352935810914344234&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "36.056901",
      "poi_longitude": "-96.005218",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-445-4162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-6242e5a430d7",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ97xKPmiUtocRKl0QBkDh5QQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f27116ea-71c1-4e06-9746-6305b7fbf3e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Office Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7286 S Lewis Pl, Tulsa, OK 74136, USA",
      "poi_short_description": "Chain selling office & school supplies, electronics & furniture (most featuring a copy center).",
      "poi_long_description": "People say this office supply store offers business cards, computers, and office supplies. They also highlight the staff is helpful, courteous, and friendly.\n\nOther reviews mention the printing service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-44e5-761e-9517-4547b05f1074.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-44e5-761e-9517-4547b05f1074",
        "storage_key": "property/6767906449165598/019d7912-44e5-761e-9517-4547b05f1074.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.officedepot.com/storelocator/ok/tulsa/office-depot-359?utm_source=google&utm_medium=organic&utm_campaign=gmb_359_website_retail",
      "poi_directions_map_url": "https://maps.google.com/?cid=5619651864428682582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "office-depot",
      "poi_latitude": "36.0585275",
      "poi_longitude": "-95.9591228",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-481-5755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-6242e5a430d7",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGwbGZryTtocRVh2itJgD_U0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_5431b23a-1234-40c7-8985-8a11df072d8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "9595 S Delaware Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers great sales and has friendly, helpful staff. They also highlight the clean and well-organized store environment.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-49f5-717f-9d37-e02259ca3d78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-49f5-717f-9d37-e02259ca3d78",
        "storage_key": "property/6767906449165598/019d7912-49f5-717f-9d37-e02259ca3d78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-426.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=15941658097467013899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0256028",
      "poi_longitude": "-95.9474268",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-299-5073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2e6-71fb-81cc-6242e5a430d7",
        "storage_key": "property/6767906449165598/019cfb3d-e2e6-71fb-81cc-6242e5a430d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYQuaYnCRtocRCztAvpMlPN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_08a17f1d-9e9c-43ad-922e-a33f18636e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6606 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Neighborhood store offering produce and meat products as well as delivery and pickup services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-484f-73c9-bcbb-96f4712fa878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-484f-73c9-bcbb-96f4712fa878",
        "storage_key": "property/6767906449165598/019d7912-484f-73c9-bcbb-96f4712fa878.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/2880-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16039408066798300372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "36.0449545",
      "poi_longitude": "-95.9031655",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-524-1435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f8-7728-b62e-149b03886763.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f8-7728-b62e-149b03886763",
        "storage_key": "property/6767906449165598/019cfb3d-e2f8-7728-b62e-149b03886763.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVBlIQmStocR1CwMBahsl94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e4f2ae7d-f280-4f7b-b07d-9802245a111b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Woody Guthrie Center",
      "poi_type": "Entertainment",
      "poi_address": "102 E Reconciliation Wy, Tulsa, OK 74103, USA",
      "poi_short_description": "Archives & exhibits related to the famed folk singer plus Dust Bowl-era & regional history displays.",
      "poi_long_description": "People say this museum offers a diverse collection of exhibits, including a popular Hip Hop exhibit, and a punk, rap, and rock n roll exhibit. They highlight the informative and engaging experience, and the well-done presentation of the exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-4f3a-7515-90c6-e59f35bdaede.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4f3a-7515-90c6-e59f35bdaede",
        "storage_key": "property/6767906449165598/019d7912-4f3a-7515-90c6-e59f35bdaede.webp",
        "width": 674,
        "height": 957
      },
      "poi_business_url": "http://woodyguthriecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859463959324375305&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "woody-guthrie-center",
      "poi_latitude": "36.1586125",
      "poi_longitude": "-95.9922848",
      "poi_miles_from_property": "10.6 mi",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 918-574-2710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f6-735c-a327-aa43a3a7590c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f6-735c-a327-aa43a3a7590c",
        "storage_key": "property/6767906449165598/019cfb3d-e2f6-735c-a327-aa43a3a7590c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Y436YLrtocRCbkfxSC2MV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a5e12532-06d8-4a23-9200-d7dbffbf0019",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Tulsa Zoo",
      "poi_type": "Entertainment",
      "poi_address": "6421 E 36th St N, Tulsa, OK 74115, USA",
      "poi_short_description": "An expansive, educational park with a huge variety of animals, plus the Safari Train & a carousel.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, sea lions, and tigers, and has a dinosaur exhibit, carousel, and playground. They highlight the membership is worth it, especially for large groups, and the zoo is family-friendly. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-518e-76f9-831a-bfb2103cfbdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-518e-76f9-831a-bfb2103cfbdb",
        "storage_key": "property/6767906449165598/019d7912-518e-76f9-831a-bfb2103cfbdb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038979359347895889&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-zoo",
      "poi_latitude": "36.2130153",
      "poi_longitude": "-95.9064904",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 918-669-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f5-74fc-b5e1-dac31edca681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f5-74fc-b5e1-dac31edca681",
        "storage_key": "property/6767906449165598/019cfb3d-e2f5-74fc-b5e1-dac31edca681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb_PwwXutocRUe5o3YmeUYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_a13d5837-3507-4a74-9eae-812536986f08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Airtopia Adventure Park - Owasso",
      "poi_type": "Entertainment",
      "poi_address": "12932 East 86th St N, Owasso, OK 74055, USA",
      "poi_short_description": "Multi-dimensional indoor amusement center offers trampolines, a warrior course, and more.",
      "poi_long_description": "People say this theme park offers a variety of fun activities, including trampolines, obstacle courses, and a virtual reality experience. They also highlight the clean and spacious facilities, and the friendly and helpful staff.\n\nOther reviews mention some attractions can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019d7912-59c2-7452-8c57-2f3f17abc0ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-59c2-7452-8c57-2f3f17abc0ef",
        "storage_key": "property/6767906449165598/019d7912-59c2-7452-8c57-2f3f17abc0ef.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.airtopiapark.com/owasso?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=3729509317578422024&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "airtopia-adventure-park-owasso",
      "poi_latitude": "36.2766921",
      "poi_longitude": "-95.8278842",
      "poi_miles_from_property": "20.0 mi",
      "poi_walking_minutes": "7 hours 22 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 918-401-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3d-e2f5-74fc-b5e1-dac31edca681.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-e2f5-74fc-b5e1-dac31edca681",
        "storage_key": "property/6767906449165598/019cfb3d-e2f5-74fc-b5e1-dac31edca681.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-TfgZDxtocRCHfF7PbgwTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_6efbb6b4-f0f5-43c5-88e4-19d5ce14242e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Bluestone Steakhouse and Seafood",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "bluestone-steakhouse-and-seafood",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94406f62-9eeb-43e0-a7f8-899a18200a9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Momo’s Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "momo-s-chophouse",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_71819152-54a2-44f9-b10a-5b9a3830d29e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Tulsa Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "tulsa-botanical-gardens",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0e2bc58-4b72-4933-bd30-83fa313f9d5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "poi_name": "Riverside Parks",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "riverside-parks",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b35af724c76ec2f0f4cbc51f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_337ccf72d8c215d59fa95262",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_cd712d92c4bd6a7fb96e20a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f70e44ca9c4b0f268e028d0d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bb5a3eacca02b07c9f34685f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_46db504726116385f54061cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_a4de4784a97bd9fab0bce671",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b0818d43-e3e0-4765-84cb-906e35bc51cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "rating": "4.0",
      "name": "",
      "text": "My cozy home is a perfect representation of who i am. Everything is as I dream from my bedroom decorated with my personal art stash along with the nice sized closet in the hall . The kitchen that shows my love for culinary arts and my love of storage in the pantry . The living room that is fun and inviting yet simple. Last but most definitely not the least my balcony where i enjoy my quiet neighborhood while drawing or painting.",
      "date": "",
      "title": "my cozy world"
    },
    {
      "id": "custom_23325f10-0e5e-4337-a7b6-1a0f58d74d2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "rating": "5.0",
      "name": "",
      "text": "Trust You all have taken care of me for 9 years. You have good security and maintenance. Management is good too. I look forward to keep doing business with you all",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_2f23d0e6-75e6-421d-8b1e-6a40901a5dc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "rating": "5.0",
      "name": "",
      "text": "Maintenance Request… The request was handled quickly, in an efficient manner, and it resolved the problem. Perfect!",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_fab90629-fd20-4c51-9099-6c6debd16d7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "rating": "4.0",
      "name": "",
      "text": "It's okay... The laundry rooms are outdated, and the machines are always breaking down and outdated. No incentives for living on the property for over a year or longer. The doors and windows don't keep the heat in during the winter nor help keep it cool during the summer with the AC on.",
      "date": "",
      "title": "Verified Renter"
    },
    {
      "id": "custom_89b644a3-edcf-4c95-9c35-ca2f22127ba6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "rating": "5.0",
      "name": "",
      "text": "Been at Country Hollow for almost nine years.  Never any problems.  Maintenance repairs always completed in a timely manner.",
      "date": "",
      "title": "Verified Renter"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_8199d19f-9a3d-43e1-8cf6-c68b647d2593",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019cfb3e-6560-711c-b1da-c4667bd8e5ef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the outdoor swimming pool and clubhouse.",
        "public_id": "019cfb3e-6560-711c-b1da-c4667bd8e5ef",
        "storage_key": "property/6767906449165598/019cfb3e-6560-711c-b1da-c4667bd8e5ef.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Country Hollow Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f478ba8d25e9a53a514338b"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-b33b-73bc-b604-8736a94ef767",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "country-hollow-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598"
    },
    {
      "lead_collector_id": "019cf79d-b3ad-70ec-835b-8fec29f437dd",
      "lead_source": "LANDING_PAGE",
      "name": "country-hollow-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "apartments-with-pool-south-tulsa",
      "search_query": "apartments with a pool south tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in South Tulsa",
      "h2_subtitle": "Discover apartments with a pool in South Tulsa. Enjoy relaxing amenities in a neighborhood that enhances your lifestyle.",
      "page_copy": "Experience the perfect blend of leisure and lifestyle at Country Hollow Apartments in South Tulsa. Our community stands out with a sparkling pool, ideal for unwinding under the sun. Whether you prefer a refreshing morning swim or a weekend afternoon by the poolside, we provide an atmosphere tailored to relaxation and enjoyment.\n\nLocated conveniently near LaFortune Park, our South Tulsa apartments offer more than just a place to live. With a modern fitness center, scenic walking trails, and a tennis court, our amenities cater to a wide range of interests. Dive into comfort and style at Country Hollow Apartments, where your perfect home with a pool in South Tulsa awaits. Schedule a visit today to see all that we offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in South Tulsa",
      "seo_description": "Find your perfect home with a pool at Country Hollow Apartments in South Tulsa. Enjoy top amenities in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-tulsa-ok",
      "search_query": "fitness center apartments tulsa ok",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Tulsa, OK",
      "h2_subtitle": "Explore apartments with a fitness center in Tulsa, OK. Achieve your health goals at Country Hollow Apartments.",
      "page_copy": "Achieving your fitness goals has never been more convenient than at Country Hollow Apartments in Tulsa, OK. Our on-site fitness center offers modern equipment, allowing you to maintain a healthy lifestyle just steps from your doorstep. Whether you're starting your day with a workout or unwinding after a busy day, our fitness center is designed to meet your needs.\n\nNestled in a vibrant part of Tulsa, Country Hollow Apartments not only prioritizes fitness but also provides a variety of leisure options. With amenities like a refreshing pool and easy access to scenic walking trails, our community supports an active living atmosphere. Discover the ideal place to call home where health and comfort meet at our Tulsa, OK apartments with a fitness center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Tulsa, OK",
      "seo_description": "Discover fitness center-equipped apartments in Tulsa, OK at Country Hollow. Achieve wellness goals close to home.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "tennis-court-apartments-near-lafortune-park",
      "search_query": "tennis court apartments near lafFortune park",
      "category": "Amenity",
      "h1_title": "Tennis Court Apartments Near LaFortune Park",
      "h2_subtitle": "Find top apartments near LaFortune Park with tennis court access. Experience active living at Country Hollow Apartments.",
      "page_copy": "Country Hollow Apartments offers a unique living experience with our tennis court, right near LaFortune Park. Perfect for tennis enthusiasts, our community provides easy access to both casual and competitive play. Imagine being able to step outside and enjoy a friendly match without leaving home, surrounded by the picturesque view of South Tulsa.\n\nOur location near LaFortune Park not only enhances your life with sports but also offers enriched outdoor experiences with walking trails nearby. Alongside the tennis court, residents enjoy additional amenities like a sparkling pool and state-of-the-art fitness center. Embrace an active lifestyle at our apartments—a stone’s throw from LaFortune Park, designed for both sport and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tennis Court Apartments Near LaFortune Park",
      "seo_description": "Discover Country Hollow Apartments with a tennis court near LaFortune Park. Enjoy active living and recreational amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "walking-trails-apartment-community-tulsa",
      "search_query": "walking trails apartment community tulsa",
      "category": "Amenity",
      "h1_title": "Walking Trails Apartment Community in Tulsa",
      "h2_subtitle": "Explore our apartment community with walking trails in Tulsa. Enjoy scenic paths at Country Hollow Apartments.",
      "page_copy": "Discover Country Hollow Apartments, a thriving apartment community in Tulsa that features beautiful walking trails. Our scenic paths provide a serene setting for a morning jog or a leisurely evening stroll, allowing you to connect with nature without leaving home. Whether you're an avid runner or simply enjoy a peaceful walk, our trails enhance your living experience.\n\nLocated near LaFortune Park, Country Hollow Apartments offers more than just trails. Dive into our luxury amenities, including a sparkling pool, fitness center, and tennis court. Our community fosters an active lifestyle, ensuring that you have everything you need for relaxation and recreation right at your doorstep. Experience the best of Tulsa living at a community with walking trails designed for your enjoyment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Walking Trails Apartment Community Tulsa",
      "seo_description": "Experience a Tulsa apartment community with scenic walking trails at Country Hollow. Enjoy outdoor paths and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "dishwasher-equipped-apartments-tulsa",
      "search_query": "dishwasher equipped apartments in tulsa",
      "category": "Amenity",
      "h1_title": "Dishwasher Equipped Apartments in Tulsa",
      "h2_subtitle": "Explore Tulsa apartments equipped with dishwashers. Country Hollow Apartments offers convenience and modern amenities.",
      "page_copy": "Discover the convenience of dishwasher equipped apartments at Country Hollow in Tulsa. Each of our floor plans is designed with your comfort in mind, featuring modern kitchens that make clean-up a breeze. Whether you're preparing a family feast or a simple meal, you'll appreciate the efficiency a dishwasher brings to daily life.\n\nNestled in the vibrant area of South Tulsa, Country Hollow Apartments not only ensures hassle-free living with top-notch amenities but also provides easy access to local attractions and community perks. Our residents enjoy a host of amenities like a sparkling pool, fitness center, and scenic walking trails. Experience a blend of comfort and convenience in our Tulsa community, perfect for those who value modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Equipped Apartments in Tulsa",
      "seo_description": "Find Tulsa apartments with a dishwasher at Country Hollow. Enjoy modern kitchen conveniences and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-south-tulsa",
      "search_query": "1 bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover stylish 1 bedroom apartments in South Tulsa at Country Hollow. Experience modern living close to amenities.",
      "page_copy": "Country Hollow Apartments offers beautiful 1 bedroom apartments in South Tulsa, ideal for singles or couples seeking a modern living space. Our thoughtfully designed floor plans provide both comfort and style, ensuring you'll feel right at home from the moment you step in. With ample living space and contemporary features, each unit is tailored to meet your lifestyle needs.\n\nLocated in the heart of South Tulsa, our community boasts access to premier amenities, from a refreshing pool to a fully-equipped fitness center. Enjoy the serene environment of our community, enhanced by nearby scenic walking trails and the convenience of high-speed internet access. Experience the perfect balance of tranquility and accessibility with our exceptional 1 bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in South Tulsa",
      "seo_description": "Find 1 bedroom apartments in South Tulsa at Country Hollow. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165598",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-tulsa-ok",
      "search_query": "2 bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Explore spacious 2 bedroom apartments in Tulsa, OK. Discover comfort and convenience at Country Hollow Apartments.",
      "page_copy": "Welcome to Country Hollow Apartments, where you’ll find spacious and stylish 2 bedroom apartments in Tulsa, OK, designed with families and roommates in mind. Our thoughtfully crafted layouts offer ample space and privacy, making them ideal for creating a comfortable home environment. Each apartment is equipped with modern amenities to enhance your living experience, from fully-featured kitchens to private living spaces.\n\nLocated conveniently in South Tulsa, our community offers residents more than just beautiful living arrangements. Amenities such as a refreshing swimming pool, a state-of-the-art fitness center, and a tennis court are just some of the perks that await you. With our scenic walking trails and proximity to LaFortune Park, you'll love the blend of nature and convenience that Country Hollow provides. Experience elevated living in Tulsa, OK, with our exceptional 2 bedroom options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fb44b-484e-7702-98c7-cca33bd53464",
        "storage_key": "property/6767906449165598/019fb44b-484e-7702-98c7-cca33bd53464.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Tulsa, OK",
      "seo_description": "Find spacious 2 bedroom apartments in Tulsa, OK at Country Hollow. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5165"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-NXCCGN23WG"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151280"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/country-hollow/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M83G88C2"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165598/019d1bd7-d45a-7617-8a45-8d70cd09f259.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-655-9642"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6441853b0a8b1e8dbf8a5aa6"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImFXUEprR2dWcHVZdDg1R09FdWxzcGc9PSIsInZhbHVlIjoiN2YySnNjNVZWcFR3Y0lLRUs5NDkrZz09IiwibWFjIjoiMmY3YmVkZDhjYWNiNGUzMDBkZGJmZGQ4ZjUyZmZlYzMyMTIwY2RjMTM2OWZmMWI2ZTRjMThmNWNkZjQ1NzI0MCJ9"
    }
  ],
  "custom_qb_id": "5165",
  "custom_ga4_id": "G-NXCCGN23WG",
  "custom_repli_id": "10041151280",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/country-hollow/register/",
  "custom_google_gtm_id": "GTM-M83G88C2",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165598/019d1bd7-d45a-7617-8a45-8d70cd09f259.pdf",
  "custom_ppc_tracking_phone_number": "800-655-9642",
  "custom_residentboost_apartment_id": "6441853b0a8b1e8dbf8a5aa6",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImFXUEprR2dWcHVZdDg1R09FdWxzcGc9PSIsInZhbHVlIjoiN2YySnNjNVZWcFR3Y0lLRUs5NDkrZz09IiwibWFjIjoiMmY3YmVkZDhjYWNiNGUzMDBkZGJmZGQ4ZjUyZmZlYzMyMTIwY2RjMTM2OWZmMWI2ZTRjMThmNWNkZjQ1NzI0MCJ9"
};

export const generatedAt = '2026-08-27T21:38:44.227Z';
